import type { PageCard } from '@/play/pageTypes'
import { CandyCardArt } from './CardArt'

/** What the home screen shows for this page; the page itself is ./index.ts, loaded when it opens. */
export const card: PageCard = {
  id: 'candy',
  number: 29,
  title: 'Candy',
  question: 'Does making candy (donuts, lollipops, jelly beans) out of shiny 3D paint feel delicious?',
  status: 'open',
  accent: '#ffd3e6',
  CardArt: CandyCardArt,
}
